<template>
  <td class="u-taR">
    <div :class="evalPanelColorClass(number)">
      <span class="number">
        {{ number !== null ? numberLocaleString(number) : '-' }}
      </span>
    </div>
    <span v-if="label" class="label">{{ label }}</span>
  </td>
</template>

<script>
import { toNumberLocaleString } from '../../../modules/localeString'
import { evalPanelColorClassNumber } from '../../../modules/colorTip'

export default {
  name: 'CompaniesAnalysisSurveysTableData',
  props: {
    number: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      required: false,
    },
    colorTipCondition: {
      type: Object,
      default: null
    }
  },
  methods: {
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
    evalPanelColorClass(number) {
      if (this.colorTipCondition === null) return ''
      return ['p-table__color--' + evalPanelColorClassNumber(this.colorTipCondition, number), 'p-table__color']
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: block;
  font-size: 10px;
  font-weight: normal;
  white-space: nowrap;
}
.p-table__color {
  justify-content: left !important;
  margin-left: 73%;
}
.number {
  margin-left: auto;
}
</style>
